export const TARGETS = {
  SIGNED_URL: 'signedUrl',
  UPLOAD_FILE: 'uploadFile'
};
